export default "__VITE_ASSET__CGRzBXTd__"